export default __webpack_public_path__ + "static/media/Organization_Line.c4101f48.svg";